import type { Styles } from 'common/types';

export const styles: Styles = {
  publisherOption: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
  },
};
